/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Biginteger } from '../model';
// @ts-ignore
import { CatalogLayersResponseVO } from '../model';
// @ts-ignore
import { Feature } from '../model';
// @ts-ignore
import { FeatureCardVO } from '../model';
// @ts-ignore
import { FeatureCollection } from '../model';
// @ts-ignore
import { FeatureDetailVO } from '../model';
// @ts-ignore
import { FeatureGroupVO } from '../model';
// @ts-ignore
import { FeaturePointerVO } from '../model';
// @ts-ignore
import { GeoObjektVO } from '../model';
// @ts-ignore
import { LayerDataFilterVO } from '../model';
// @ts-ignore
import { LayerVO } from '../model';
// @ts-ignore
import { LegendItemVO } from '../model';
// @ts-ignore
import { SearchGroupResponseVO } from '../model';
// @ts-ignore
import { SearchLayerRequestVO } from '../model';
// @ts-ignore
import { SearchResponseVO } from '../model';
// @ts-ignore
import { SearchResultVO } from '../model';
// @ts-ignore
import { SearchTypeVO } from '../model';
// @ts-ignore
import { TopicVO } from '../model';
// @ts-ignore
import { TopicVisibility } from '../model';
// @ts-ignore
import { TopicsResponseVO } from '../model';
// @ts-ignore
import { VypisZKatastruVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * ServicesControllerApi - axios parameter creator
 * @export
 */
export const ServicesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} topic 
         * @param {string} lang 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogLayers: async (topic: string, lang: string, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getCatalogLayers', 'topic', topic)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getCatalogLayers', 'lang', lang)
            const localVarPath = `/api/services/{topic}/catalog-server`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} component Název komponenty
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: async (component: string, context: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'component' is not null or undefined
            assertParamExists('getConfig', 'component', component)
            // verify required parameter 'context' is not null or undefined
            assertParamExists('getConfig', 'context', context)
            const localVarPath = `/api/services/config/{component}`
                .replace(`{${"component"}}`, encodeURIComponent(String(component)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lehká varianta detailu pro seznam objektů ve výřezu (panel hledání). Jedním dotazem vrátí vše, co potřebuje kartička v seznamu – název, kódy bezbariérové přístupnosti a ID první fotografie – bez renderování HTML, akcí a logů. Nahrazuje kombinaci getDataByIds + getLayerAttributes + detail, aby se výřezový seznam odbavil jediným requestem.
         * @param {string} topic 
         * @param {string} [context] 
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureCards: async (topic: string, context?: string, featurePointerVO?: Array<FeaturePointerVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getFeatureCards', 'topic', topic)
            const localVarPath = `/api/services/{topic}/map-server/cards`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featurePointerVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Získá data vrstvy v GeoJSON formátu
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {string} geometryFormat 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureData: async (topic: string, layerId: number, featureId: string, geometryFormat: string, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getFeatureData', 'topic', topic)
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getFeatureData', 'layerId', layerId)
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('getFeatureData', 'featureId', featureId)
            // verify required parameter 'geometryFormat' is not null or undefined
            assertParamExists('getFeatureData', 'geometryFormat', geometryFormat)
            const localVarPath = `/api/services/{topic}/map-server/{layerId}/{featureId}`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)))
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)))
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (geometryFormat !== undefined) {
                localVarQueryParameter['geometryFormat'] = geometryFormat;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} [context] 
         * @param {string} [type] 
         * @param {string} [platform] 
         * @param {string} [reCaptchaResponse] 
         * @param {boolean} [isReactNativeInWebView] 
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureDetail: async (topic: string, context?: string, type?: string, platform?: string, reCaptchaResponse?: string, isReactNativeInWebView?: boolean, featurePointerVO?: Array<FeaturePointerVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getFeatureDetail', 'topic', topic)
            const localVarPath = `/api/services/{topic}/map-server/detail`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (reCaptchaResponse !== undefined) {
                localVarQueryParameter['reCaptchaResponse'] = reCaptchaResponse;
            }

            if (isReactNativeInWebView !== undefined) {
                localVarQueryParameter['isReactNativeInWebView'] = isReactNativeInWebView;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featurePointerVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {string} [context] 
         * @param {string} [reCaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureDetailPopup: async (topic: string, layerId: number, featureId: string, context?: string, reCaptchaResponse?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getFeatureDetailPopup', 'topic', topic)
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getFeatureDetailPopup', 'layerId', layerId)
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('getFeatureDetailPopup', 'featureId', featureId)
            const localVarPath = `/api/services/{topic}/map-server/{layerId}/{featureId}/html-popup`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)))
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)))
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (reCaptchaResponse !== undefined) {
                localVarQueryParameter['reCaptchaResponse'] = reCaptchaResponse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Získá data vrstvy v GeoJSON formátu
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} geometryFormat 
         * @param {string} [context] 
         * @param {LayerDataFilterVO} [layerDataFilterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerData: async (topic: string, layerId: number, geometryFormat: string, context?: string, layerDataFilterVO?: LayerDataFilterVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getLayerData', 'topic', topic)
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getLayerData', 'layerId', layerId)
            // verify required parameter 'geometryFormat' is not null or undefined
            assertParamExists('getLayerData', 'geometryFormat', geometryFormat)
            const localVarPath = `/api/services/{topic}/map-server/{layerId}`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)))
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (geometryFormat !== undefined) {
                localVarQueryParameter['geometryFormat'] = geometryFormat;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layerDataFilterVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} requestBody Pole id vrstev
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerLegends: async (requestBody: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getLayerLegends', 'requestBody', requestBody)
            const localVarPath = `/api/services/layers-legend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} lang 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayersConfig: async (lang: string, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getLayersConfig', 'lang', lang)
            const localVarPath = `/api/services/layers-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} coordinates 
         * @param {Array<number>} [layerIds] 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayersMetadata: async (coordinates: Array<number>, layerIds?: Array<number>, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'coordinates' is not null or undefined
            assertParamExists('getLayersMetadata', 'coordinates', coordinates)
            const localVarPath = `/api/services/layers-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (coordinates) {
                localVarQueryParameter['coordinates'] = coordinates;
            }

            if (layerIds) {
                localVarQueryParameter['layerIds'] = layerIds;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} leftTopX 
         * @param {number} leftTopY 
         * @param {number} rightBottomX 
         * @param {number} rightBottomY 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjectsInArea: async (topic: string, leftTopX: number, leftTopY: number, rightBottomX: number, rightBottomY: number, layerId: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getObjectsInArea', 'topic', topic)
            // verify required parameter 'leftTopX' is not null or undefined
            assertParamExists('getObjectsInArea', 'leftTopX', leftTopX)
            // verify required parameter 'leftTopY' is not null or undefined
            assertParamExists('getObjectsInArea', 'leftTopY', leftTopY)
            // verify required parameter 'rightBottomX' is not null or undefined
            assertParamExists('getObjectsInArea', 'rightBottomX', rightBottomX)
            // verify required parameter 'rightBottomY' is not null or undefined
            assertParamExists('getObjectsInArea', 'rightBottomY', rightBottomY)
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getObjectsInArea', 'layerId', layerId)
            const localVarPath = `/api/services/{topic}/map-server/{layerId}/objects-in-area`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)))
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (leftTopX !== undefined) {
                localVarQueryParameter['leftTopX'] = leftTopX;
            }

            if (leftTopY !== undefined) {
                localVarQueryParameter['leftTopY'] = leftTopY;
            }

            if (rightBottomX !== undefined) {
                localVarQueryParameter['rightBottomX'] = rightBottomX;
            }

            if (rightBottomY !== undefined) {
                localVarQueryParameter['rightBottomY'] = rightBottomY;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} typ 
         * @param {Array<Biginteger>} ids 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjektVlastnik: async (topic: string, typ: string, ids: Array<Biginteger>, context: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getObjektVlastnik', 'topic', topic)
            // verify required parameter 'typ' is not null or undefined
            assertParamExists('getObjektVlastnik', 'typ', typ)
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getObjektVlastnik', 'ids', ids)
            // verify required parameter 'context' is not null or undefined
            assertParamExists('getObjektVlastnik', 'context', context)
            const localVarPath = `/api/services/{topic}/map-server/objekt-vlastnik`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typ !== undefined) {
                localVarQueryParameter['typ'] = typ;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemaData: async (topic: string, layerId: number, featureId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('getSchemaData', 'topic', topic)
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getSchemaData', 'layerId', layerId)
            // verify required parameter 'featureId' is not null or undefined
            assertParamExists('getSchemaData', 'featureId', featureId)
            const localVarPath = `/api/services/{topic}/map-server/{layerId}/{featureId}/schema`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)))
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)))
                .replace(`{${"featureId"}}`, encodeURIComponent(String(featureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pro zadané vrstvy vrátí popisky atributů, podle kterých lze ve vrstvě fulltextově vyhledávat (mapa idVrstvy -> seznam popisků atributů). Vrstvy bez vyhledávatelných atributů v mapě nejsou.
         * @param {Array<string>} requestBody Pole id vrstev
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchableAttributes: async (requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getSearchableAttributes', 'requestBody', requestBody)
            const localVarPath = `/api/services/searchable-attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsConfig: async (context?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/services/topics-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [context] 
         * @param {TopicVisibility} [topicVisibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsMap: async (context?: string, topicVisibility?: TopicVisibility, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (topicVisibility !== undefined) {
                localVarQueryParameter['topicVisibility'] = topicVisibility;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<number>} geometry 
         * @param {Array<SearchTypeVO>} types 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identifyObjectRen: async (topic: string, geometry: Array<number>, types: Array<SearchTypeVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('identifyObjectRen', 'topic', topic)
            // verify required parameter 'geometry' is not null or undefined
            assertParamExists('identifyObjectRen', 'geometry', geometry)
            // verify required parameter 'types' is not null or undefined
            assertParamExists('identifyObjectRen', 'types', types)
            const localVarPath = `/api/services/{topic}/map-server/identify-objekt`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (geometry) {
                localVarQueryParameter['geometry'] = geometry;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} searchText 
         * @param {string} lang 
         * @param {string} type 
         * @param {string} [context] 
         * @param {string} [bbox] 
         * @param {string} [features] 
         * @param {boolean} [detailInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (topic: string, searchText: string, lang: string, type: string, context?: string, bbox?: string, features?: string, detailInfo?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('search', 'topic', topic)
            // verify required parameter 'searchText' is not null or undefined
            assertParamExists('search', 'searchText', searchText)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('search', 'lang', lang)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('search', 'type', type)
            const localVarPath = `/api/services/{topic}/search-server`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (features !== undefined) {
                localVarQueryParameter['features'] = features;
            }

            if (detailInfo !== undefined) {
                localVarQueryParameter['detailInfo'] = detailInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} x 
         * @param {number} y 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByCoordinates: async (x: number, y: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x' is not null or undefined
            assertParamExists('searchByCoordinates', 'x', x)
            // verify required parameter 'y' is not null or undefined
            assertParamExists('searchByCoordinates', 'y', y)
            const localVarPath = `/api/services/search-server/by-coords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (x !== undefined) {
                localVarQueryParameter['X'] = x;
            }

            if (y !== undefined) {
                localVarQueryParameter['Y'] = y;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {SearchLayerRequestVO} searchLayerRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLayer: async (topic: string, searchLayerRequestVO: SearchLayerRequestVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('searchLayer', 'topic', topic)
            // verify required parameter 'searchLayerRequestVO' is not null or undefined
            assertParamExists('searchLayer', 'searchLayerRequestVO', searchLayerRequestVO)
            const localVarPath = `/api/services/{topic}/search-fulltext`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchLayerRequestVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<string>} featureIds 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectObjekt: async (topic: string, featureIds: Array<string>, layerId: number, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('selectObjekt', 'topic', topic)
            // verify required parameter 'featureIds' is not null or undefined
            assertParamExists('selectObjekt', 'featureIds', featureIds)
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('selectObjekt', 'layerId', layerId)
            const localVarPath = `/api/services/{topic}/map-server/{layerId}/select-objects`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)))
                .replace(`{${"layerId"}}`, encodeURIComponent(String(layerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (featureIds) {
                localVarQueryParameter['featureIds'] = featureIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServicesControllerApi - functional programming interface
 * @export
 */
export const ServicesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServicesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} topic 
         * @param {string} lang 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogLayers(topic: string, lang: string, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogLayersResponseVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogLayers(topic, lang, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} component Název komponenty
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfig(component: string, context: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfig(component, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lehká varianta detailu pro seznam objektů ve výřezu (panel hledání). Jedním dotazem vrátí vše, co potřebuje kartička v seznamu – název, kódy bezbariérové přístupnosti a ID první fotografie – bez renderování HTML, akcí a logů. Nahrazuje kombinaci getDataByIds + getLayerAttributes + detail, aby se výřezový seznam odbavil jediným requestem.
         * @param {string} topic 
         * @param {string} [context] 
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureCards(topic: string, context?: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureCardVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureCards(topic, context, featurePointerVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Získá data vrstvy v GeoJSON formátu
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {string} geometryFormat 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureData(topic: string, layerId: number, featureId: string, geometryFormat: string, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureData(topic, layerId, featureId, geometryFormat, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} [context] 
         * @param {string} [type] 
         * @param {string} [platform] 
         * @param {string} [reCaptchaResponse] 
         * @param {boolean} [isReactNativeInWebView] 
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureDetail(topic: string, context?: string, type?: string, platform?: string, reCaptchaResponse?: string, isReactNativeInWebView?: boolean, featurePointerVO?: Array<FeaturePointerVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureDetailVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureDetail(topic, context, type, platform, reCaptchaResponse, isReactNativeInWebView, featurePointerVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {string} [context] 
         * @param {string} [reCaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureDetailPopup(topic: string, layerId: number, featureId: string, context?: string, reCaptchaResponse?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureDetailPopup(topic, layerId, featureId, context, reCaptchaResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Získá data vrstvy v GeoJSON formátu
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} geometryFormat 
         * @param {string} [context] 
         * @param {LayerDataFilterVO} [layerDataFilterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLayerData(topic: string, layerId: number, geometryFormat: string, context?: string, layerDataFilterVO?: LayerDataFilterVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollection>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getLayerData(topic, layerId, geometryFormat, context, layerDataFilterVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} requestBody Pole id vrstev
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLayerLegends(requestBody: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: LegendItemVO; }>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getLayerLegends(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} lang 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLayersConfig(lang: string, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: LayerVO; }>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getLayersConfig(lang, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} coordinates 
         * @param {Array<number>} [layerIds] 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLayersMetadata(coordinates: Array<number>, layerIds?: Array<number>, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Feature>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getLayersMetadata(coordinates, layerIds, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} leftTopX 
         * @param {number} leftTopY 
         * @param {number} rightBottomX 
         * @param {number} rightBottomY 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObjectsInArea(topic: string, leftTopX: number, leftTopY: number, rightBottomX: number, rightBottomY: number, layerId: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getObjectsInArea(topic, leftTopX, leftTopY, rightBottomX, rightBottomY, layerId, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} typ 
         * @param {Array<Biginteger>} ids 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObjektVlastnik(topic: string, typ: string, ids: Array<Biginteger>, context: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VypisZKatastruVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getObjektVlastnik(topic, typ, ids, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchemaData(topic: string, layerId: number, featureId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureGroupVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchemaData(topic, layerId, featureId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Pro zadané vrstvy vrátí popisky atributů, podle kterých lze ve vrstvě fulltextově vyhledávat (mapa idVrstvy -> seznam popisků atributů). Vrstvy bez vyhledávatelných atributů v mapě nejsou.
         * @param {Array<string>} requestBody Pole id vrstev
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchableAttributes(requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getSearchableAttributes(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicsConfig(context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TopicVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicsConfig(context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [context] 
         * @param {TopicVisibility} [topicVisibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicsMap(context?: string, topicVisibility?: TopicVisibility, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopicsResponseVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicsMap(context, topicVisibility, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<number>} geometry 
         * @param {Array<SearchTypeVO>} types 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identifyObjectRen(topic: string, geometry: Array<number>, types: Array<SearchTypeVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeoObjektVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.identifyObjectRen(topic, geometry, types, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} searchText 
         * @param {string} lang 
         * @param {string} type 
         * @param {string} [context] 
         * @param {string} [bbox] 
         * @param {string} [features] 
         * @param {boolean} [detailInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(topic: string, searchText: string, lang: string, type: string, context?: string, bbox?: string, features?: string, detailInfo?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchResultVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.search(topic, searchText, lang, type, context, bbox, features, detailInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} x 
         * @param {number} y 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByCoordinates(x: number, y: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResponseVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByCoordinates(x, y, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {SearchLayerRequestVO} searchLayerRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLayer(topic: string, searchLayerRequestVO: SearchLayerRequestVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupResponseVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLayer(topic, searchLayerRequestVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<string>} featureIds 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selectObjekt(topic: string, featureIds: Array<string>, layerId: number, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.selectObjekt(topic, featureIds, layerId, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServicesControllerApi - factory interface
 * @export
 */
export const ServicesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServicesControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} topic 
         * @param {string} lang 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogLayers(topic: string, lang: string, context?: string, options?: any): AxiosPromise<CatalogLayersResponseVO> {
            return localVarFp.getCatalogLayers(topic, lang, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} component Název komponenty
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(component: string, context: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getConfig(component, context, options).then((request) => request(axios, basePath));
        },
        /**
         * Lehká varianta detailu pro seznam objektů ve výřezu (panel hledání). Jedním dotazem vrátí vše, co potřebuje kartička v seznamu – název, kódy bezbariérové přístupnosti a ID první fotografie – bez renderování HTML, akcí a logů. Nahrazuje kombinaci getDataByIds + getLayerAttributes + detail, aby se výřezový seznam odbavil jediným requestem.
         * @param {string} topic 
         * @param {string} [context] 
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureCards(topic: string, context?: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): AxiosPromise<Array<FeatureCardVO>> {
            return localVarFp.getFeatureCards(topic, context, featurePointerVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Získá data vrstvy v GeoJSON formátu
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {string} geometryFormat 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureData(topic: string, layerId: number, featureId: string, geometryFormat: string, context?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getFeatureData(topic, layerId, featureId, geometryFormat, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} [context] 
         * @param {string} [type] 
         * @param {string} [platform] 
         * @param {string} [reCaptchaResponse] 
         * @param {boolean} [isReactNativeInWebView] 
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureDetail(topic: string, context?: string, type?: string, platform?: string, reCaptchaResponse?: string, isReactNativeInWebView?: boolean, featurePointerVO?: Array<FeaturePointerVO>, options?: any): AxiosPromise<Array<FeatureDetailVO>> {
            return localVarFp.getFeatureDetail(topic, context, type, platform, reCaptchaResponse, isReactNativeInWebView, featurePointerVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {string} [context] 
         * @param {string} [reCaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureDetailPopup(topic: string, layerId: number, featureId: string, context?: string, reCaptchaResponse?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getFeatureDetailPopup(topic, layerId, featureId, context, reCaptchaResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * Získá data vrstvy v GeoJSON formátu
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} geometryFormat 
         * @param {string} [context] 
         * @param {LayerDataFilterVO} [layerDataFilterVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerData(topic: string, layerId: number, geometryFormat: string, context?: string, layerDataFilterVO?: LayerDataFilterVO, options?: any): AxiosPromise<FeatureCollection> {
            return localVarFp.getLayerData(topic, layerId, geometryFormat, context, layerDataFilterVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} requestBody Pole id vrstev
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerLegends(requestBody: Array<number>, options?: any): AxiosPromise<{ [key: string]: LegendItemVO; }> {
            return localVarFp.getLayerLegends(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} lang 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayersConfig(lang: string, context?: string, options?: any): AxiosPromise<{ [key: string]: LayerVO; }> {
            return localVarFp.getLayersConfig(lang, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} coordinates 
         * @param {Array<number>} [layerIds] 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayersMetadata(coordinates: Array<number>, layerIds?: Array<number>, context?: string, options?: any): AxiosPromise<Array<Feature>> {
            return localVarFp.getLayersMetadata(coordinates, layerIds, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} leftTopX 
         * @param {number} leftTopY 
         * @param {number} rightBottomX 
         * @param {number} rightBottomY 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjectsInArea(topic: string, leftTopX: number, leftTopY: number, rightBottomX: number, rightBottomY: number, layerId: number, context?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getObjectsInArea(topic, leftTopX, leftTopY, rightBottomX, rightBottomY, layerId, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} typ 
         * @param {Array<Biginteger>} ids 
         * @param {string} context 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjektVlastnik(topic: string, typ: string, ids: Array<Biginteger>, context: string, options?: any): AxiosPromise<VypisZKatastruVO> {
            return localVarFp.getObjektVlastnik(topic, typ, ids, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {number} layerId 
         * @param {string} featureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemaData(topic: string, layerId: number, featureId: string, options?: any): AxiosPromise<FeatureGroupVO> {
            return localVarFp.getSchemaData(topic, layerId, featureId, options).then((request) => request(axios, basePath));
        },
        /**
         * Pro zadané vrstvy vrátí popisky atributů, podle kterých lze ve vrstvě fulltextově vyhledávat (mapa idVrstvy -> seznam popisků atributů). Vrstvy bez vyhledávatelných atributů v mapě nejsou.
         * @param {Array<string>} requestBody Pole id vrstev
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchableAttributes(requestBody: Array<string>, options?: any): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.getSearchableAttributes(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsConfig(context?: string, options?: any): AxiosPromise<Array<TopicVO>> {
            return localVarFp.getTopicsConfig(context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [context] 
         * @param {TopicVisibility} [topicVisibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsMap(context?: string, topicVisibility?: TopicVisibility, options?: any): AxiosPromise<TopicsResponseVO> {
            return localVarFp.getTopicsMap(context, topicVisibility, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<number>} geometry 
         * @param {Array<SearchTypeVO>} types 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identifyObjectRen(topic: string, geometry: Array<number>, types: Array<SearchTypeVO>, options?: any): AxiosPromise<Array<GeoObjektVO>> {
            return localVarFp.identifyObjectRen(topic, geometry, types, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {string} searchText 
         * @param {string} lang 
         * @param {string} type 
         * @param {string} [context] 
         * @param {string} [bbox] 
         * @param {string} [features] 
         * @param {boolean} [detailInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(topic: string, searchText: string, lang: string, type: string, context?: string, bbox?: string, features?: string, detailInfo?: boolean, options?: any): AxiosPromise<Array<SearchResultVO>> {
            return localVarFp.search(topic, searchText, lang, type, context, bbox, features, detailInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} x 
         * @param {number} y 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByCoordinates(x: number, y: number, context?: string, options?: any): AxiosPromise<SearchResponseVO> {
            return localVarFp.searchByCoordinates(x, y, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {SearchLayerRequestVO} searchLayerRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLayer(topic: string, searchLayerRequestVO: SearchLayerRequestVO, options?: any): AxiosPromise<SearchGroupResponseVO> {
            return localVarFp.searchLayer(topic, searchLayerRequestVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} topic 
         * @param {Array<string>} featureIds 
         * @param {number} layerId 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectObjekt(topic: string, featureIds: Array<string>, layerId: number, context?: string, options?: any): AxiosPromise<string> {
            return localVarFp.selectObjekt(topic, featureIds, layerId, context, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServicesControllerApi - interface
 * @export
 * @interface ServicesControllerApi
 */
export interface ServicesControllerApiInterface {
    /**
     * 
     * @param {string} topic 
     * @param {string} lang 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getCatalogLayers(topic: string, lang: string, context?: string, options?: any): AxiosPromise<CatalogLayersResponseVO>;

    /**
     * 
     * @param {string} component Název komponenty
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getConfig(component: string, context: string, options?: any): AxiosPromise<{ [key: string]: string; }>;

    /**
     * Lehká varianta detailu pro seznam objektů ve výřezu (panel hledání). Jedním dotazem vrátí vše, co potřebuje kartička v seznamu – název, kódy bezbariérové přístupnosti a ID první fotografie – bez renderování HTML, akcí a logů. Nahrazuje kombinaci getDataByIds + getLayerAttributes + detail, aby se výřezový seznam odbavil jediným requestem.
     * @param {string} topic 
     * @param {string} [context] 
     * @param {Array<FeaturePointerVO>} [featurePointerVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getFeatureCards(topic: string, context?: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): AxiosPromise<Array<FeatureCardVO>>;

    /**
     * Získá data vrstvy v GeoJSON formátu
     * @param {string} topic 
     * @param {number} layerId 
     * @param {string} featureId 
     * @param {string} geometryFormat 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getFeatureData(topic: string, layerId: number, featureId: string, geometryFormat: string, context?: string, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {string} topic 
     * @param {string} [context] 
     * @param {string} [type] 
     * @param {string} [platform] 
     * @param {string} [reCaptchaResponse] 
     * @param {boolean} [isReactNativeInWebView] 
     * @param {Array<FeaturePointerVO>} [featurePointerVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getFeatureDetail(topic: string, context?: string, type?: string, platform?: string, reCaptchaResponse?: string, isReactNativeInWebView?: boolean, featurePointerVO?: Array<FeaturePointerVO>, options?: any): AxiosPromise<Array<FeatureDetailVO>>;

    /**
     * 
     * @param {string} topic 
     * @param {number} layerId 
     * @param {string} featureId 
     * @param {string} [context] 
     * @param {string} [reCaptchaResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getFeatureDetailPopup(topic: string, layerId: number, featureId: string, context?: string, reCaptchaResponse?: string, options?: any): AxiosPromise<string>;

    /**
     * Získá data vrstvy v GeoJSON formátu
     * @param {string} topic 
     * @param {number} layerId 
     * @param {string} geometryFormat 
     * @param {string} [context] 
     * @param {LayerDataFilterVO} [layerDataFilterVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getLayerData(topic: string, layerId: number, geometryFormat: string, context?: string, layerDataFilterVO?: LayerDataFilterVO, options?: any): AxiosPromise<FeatureCollection>;

    /**
     * 
     * @param {Array<number>} requestBody Pole id vrstev
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getLayerLegends(requestBody: Array<number>, options?: any): AxiosPromise<{ [key: string]: LegendItemVO; }>;

    /**
     * 
     * @param {string} lang 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getLayersConfig(lang: string, context?: string, options?: any): AxiosPromise<{ [key: string]: LayerVO; }>;

    /**
     * 
     * @param {Array<number>} coordinates 
     * @param {Array<number>} [layerIds] 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getLayersMetadata(coordinates: Array<number>, layerIds?: Array<number>, context?: string, options?: any): AxiosPromise<Array<Feature>>;

    /**
     * 
     * @param {string} topic 
     * @param {number} leftTopX 
     * @param {number} leftTopY 
     * @param {number} rightBottomX 
     * @param {number} rightBottomY 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getObjectsInArea(topic: string, leftTopX: number, leftTopY: number, rightBottomX: number, rightBottomY: number, layerId: number, context?: string, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {string} topic 
     * @param {string} typ 
     * @param {Array<Biginteger>} ids 
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getObjektVlastnik(topic: string, typ: string, ids: Array<Biginteger>, context: string, options?: any): AxiosPromise<VypisZKatastruVO>;

    /**
     * 
     * @param {string} topic 
     * @param {number} layerId 
     * @param {string} featureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getSchemaData(topic: string, layerId: number, featureId: string, options?: any): AxiosPromise<FeatureGroupVO>;

    /**
     * Pro zadané vrstvy vrátí popisky atributů, podle kterých lze ve vrstvě fulltextově vyhledávat (mapa idVrstvy -> seznam popisků atributů). Vrstvy bez vyhledávatelných atributů v mapě nejsou.
     * @param {Array<string>} requestBody Pole id vrstev
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getSearchableAttributes(requestBody: Array<string>, options?: any): AxiosPromise<{ [key: string]: Array<string>; }>;

    /**
     * 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getTopicsConfig(context?: string, options?: any): AxiosPromise<Array<TopicVO>>;

    /**
     * 
     * @param {string} [context] 
     * @param {TopicVisibility} [topicVisibility] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    getTopicsMap(context?: string, topicVisibility?: TopicVisibility, options?: any): AxiosPromise<TopicsResponseVO>;

    /**
     * 
     * @param {string} topic 
     * @param {Array<number>} geometry 
     * @param {Array<SearchTypeVO>} types 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    identifyObjectRen(topic: string, geometry: Array<number>, types: Array<SearchTypeVO>, options?: any): AxiosPromise<Array<GeoObjektVO>>;

    /**
     * 
     * @param {string} topic 
     * @param {string} searchText 
     * @param {string} lang 
     * @param {string} type 
     * @param {string} [context] 
     * @param {string} [bbox] 
     * @param {string} [features] 
     * @param {boolean} [detailInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    search(topic: string, searchText: string, lang: string, type: string, context?: string, bbox?: string, features?: string, detailInfo?: boolean, options?: any): AxiosPromise<Array<SearchResultVO>>;

    /**
     * 
     * @param {number} x 
     * @param {number} y 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    searchByCoordinates(x: number, y: number, context?: string, options?: any): AxiosPromise<SearchResponseVO>;

    /**
     * 
     * @param {string} topic 
     * @param {SearchLayerRequestVO} searchLayerRequestVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    searchLayer(topic: string, searchLayerRequestVO: SearchLayerRequestVO, options?: any): AxiosPromise<SearchGroupResponseVO>;

    /**
     * 
     * @param {string} topic 
     * @param {Array<string>} featureIds 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApiInterface
     */
    selectObjekt(topic: string, featureIds: Array<string>, layerId: number, context?: string, options?: any): AxiosPromise<string>;

}

/**
 * ServicesControllerApi - object-oriented interface
 * @export
 * @class ServicesControllerApi
 * @extends {BaseAPI}
 */
export class ServicesControllerApi extends BaseAPI implements ServicesControllerApiInterface {
    /**
     * 
     * @param {string} topic 
     * @param {string} lang 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getCatalogLayers(topic: string, lang: string, context?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getCatalogLayers(topic, lang, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} component Název komponenty
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getConfig(component: string, context: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getConfig(component, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lehká varianta detailu pro seznam objektů ve výřezu (panel hledání). Jedním dotazem vrátí vše, co potřebuje kartička v seznamu – název, kódy bezbariérové přístupnosti a ID první fotografie – bez renderování HTML, akcí a logů. Nahrazuje kombinaci getDataByIds + getLayerAttributes + detail, aby se výřezový seznam odbavil jediným requestem.
     * @param {string} topic 
     * @param {string} [context] 
     * @param {Array<FeaturePointerVO>} [featurePointerVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getFeatureCards(topic: string, context?: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any) {
        return ServicesControllerApiFp(this.configuration).getFeatureCards(topic, context, featurePointerVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Získá data vrstvy v GeoJSON formátu
     * @param {string} topic 
     * @param {number} layerId 
     * @param {string} featureId 
     * @param {string} geometryFormat 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getFeatureData(topic: string, layerId: number, featureId: string, geometryFormat: string, context?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getFeatureData(topic, layerId, featureId, geometryFormat, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {string} [context] 
     * @param {string} [type] 
     * @param {string} [platform] 
     * @param {string} [reCaptchaResponse] 
     * @param {boolean} [isReactNativeInWebView] 
     * @param {Array<FeaturePointerVO>} [featurePointerVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getFeatureDetail(topic: string, context?: string, type?: string, platform?: string, reCaptchaResponse?: string, isReactNativeInWebView?: boolean, featurePointerVO?: Array<FeaturePointerVO>, options?: any) {
        return ServicesControllerApiFp(this.configuration).getFeatureDetail(topic, context, type, platform, reCaptchaResponse, isReactNativeInWebView, featurePointerVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {number} layerId 
     * @param {string} featureId 
     * @param {string} [context] 
     * @param {string} [reCaptchaResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getFeatureDetailPopup(topic: string, layerId: number, featureId: string, context?: string, reCaptchaResponse?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getFeatureDetailPopup(topic, layerId, featureId, context, reCaptchaResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Získá data vrstvy v GeoJSON formátu
     * @param {string} topic 
     * @param {number} layerId 
     * @param {string} geometryFormat 
     * @param {string} [context] 
     * @param {LayerDataFilterVO} [layerDataFilterVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getLayerData(topic: string, layerId: number, geometryFormat: string, context?: string, layerDataFilterVO?: LayerDataFilterVO, options?: any) {
        return ServicesControllerApiFp(this.configuration).getLayerData(topic, layerId, geometryFormat, context, layerDataFilterVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} requestBody Pole id vrstev
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getLayerLegends(requestBody: Array<number>, options?: any) {
        return ServicesControllerApiFp(this.configuration).getLayerLegends(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} lang 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getLayersConfig(lang: string, context?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getLayersConfig(lang, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} coordinates 
     * @param {Array<number>} [layerIds] 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getLayersMetadata(coordinates: Array<number>, layerIds?: Array<number>, context?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getLayersMetadata(coordinates, layerIds, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {number} leftTopX 
     * @param {number} leftTopY 
     * @param {number} rightBottomX 
     * @param {number} rightBottomY 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getObjectsInArea(topic: string, leftTopX: number, leftTopY: number, rightBottomX: number, rightBottomY: number, layerId: number, context?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getObjectsInArea(topic, leftTopX, leftTopY, rightBottomX, rightBottomY, layerId, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {string} typ 
     * @param {Array<Biginteger>} ids 
     * @param {string} context 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getObjektVlastnik(topic: string, typ: string, ids: Array<Biginteger>, context: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getObjektVlastnik(topic, typ, ids, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {number} layerId 
     * @param {string} featureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getSchemaData(topic: string, layerId: number, featureId: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getSchemaData(topic, layerId, featureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pro zadané vrstvy vrátí popisky atributů, podle kterých lze ve vrstvě fulltextově vyhledávat (mapa idVrstvy -> seznam popisků atributů). Vrstvy bez vyhledávatelných atributů v mapě nejsou.
     * @param {Array<string>} requestBody Pole id vrstev
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getSearchableAttributes(requestBody: Array<string>, options?: any) {
        return ServicesControllerApiFp(this.configuration).getSearchableAttributes(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getTopicsConfig(context?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).getTopicsConfig(context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [context] 
     * @param {TopicVisibility} [topicVisibility] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public getTopicsMap(context?: string, topicVisibility?: TopicVisibility, options?: any) {
        return ServicesControllerApiFp(this.configuration).getTopicsMap(context, topicVisibility, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {Array<number>} geometry 
     * @param {Array<SearchTypeVO>} types 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public identifyObjectRen(topic: string, geometry: Array<number>, types: Array<SearchTypeVO>, options?: any) {
        return ServicesControllerApiFp(this.configuration).identifyObjectRen(topic, geometry, types, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {string} searchText 
     * @param {string} lang 
     * @param {string} type 
     * @param {string} [context] 
     * @param {string} [bbox] 
     * @param {string} [features] 
     * @param {boolean} [detailInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public search(topic: string, searchText: string, lang: string, type: string, context?: string, bbox?: string, features?: string, detailInfo?: boolean, options?: any) {
        return ServicesControllerApiFp(this.configuration).search(topic, searchText, lang, type, context, bbox, features, detailInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} x 
     * @param {number} y 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public searchByCoordinates(x: number, y: number, context?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).searchByCoordinates(x, y, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {SearchLayerRequestVO} searchLayerRequestVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public searchLayer(topic: string, searchLayerRequestVO: SearchLayerRequestVO, options?: any) {
        return ServicesControllerApiFp(this.configuration).searchLayer(topic, searchLayerRequestVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} topic 
     * @param {Array<string>} featureIds 
     * @param {number} layerId 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServicesControllerApi
     */
    public selectObjekt(topic: string, featureIds: Array<string>, layerId: number, context?: string, options?: any) {
        return ServicesControllerApiFp(this.configuration).selectObjekt(topic, featureIds, layerId, context, options).then((request) => request(this.axios, this.basePath));
    }
}
